import {FC, ReactNode} from "react";
import {Column} from "./Layout.tsx";
import {Text} from "../style/typography.tsx";


interface Props {
    title: string,
    children: ReactNode
}

const NavigationSection: FC<Props> = ({title, children}) => {
    return <Column gap="12">
        <Text role="description" size="1" weight="regular">{title}</Text>
        {children}
    </Column>
}

export default NavigationSection